import * as React from 'react';

import { useFocusControl } from '../../Utils';
import { IInputError } from '../common';
import { useInputControlContext } from '../InputControl/InputControlContext';
import { useHoverContext } from '../Context/hoverContext';

import { IInputTextAreaField } from './InputTextAreaField';
import { StyledTextArea } from './StyledTextArea';

type TextAreaProps = IInputTextAreaField & IInputError;

export const TextArea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement> & TextAreaProps>((
  props, ref
) => {
  const {
    id,
    inputProps,
  } = props;
  const isDisabled = !!(inputProps && inputProps.disabled);
  const { isHovered, toggleHover } = useHoverContext();
  const toggleInputHover = isDisabled ? undefined : toggleHover ;
  const { clickFocus, stopClickFocus, resetClickFocus } = useFocusControl();
  const { error, ariaDescribedby } = useInputControlContext();
  const ariaDescribedbyWithInputProps = inputProps && inputProps['aria-describedby'] ?
    `${ariaDescribedby} ${inputProps['aria-describedby']}` : ariaDescribedby;

  return (
    <StyledTextArea
      {...inputProps}
      aria-describedby={ariaDescribedbyWithInputProps ? ariaDescribedbyWithInputProps : undefined}
      error={error}
      id={id}
      isHovered={isHovered}
      ref={ref}
      onBlur={resetClickFocus}
      onMouseDown={stopClickFocus}
      onMouseOver={toggleInputHover}
      onMouseLeave={toggleInputHover}
      clickFocus={clickFocus}
    />
  );
});

export default TextArea;
